import React from 'react';
import './AudienceProfilesIntro.css';
import ScrollArrowButton from './ScrollArrowButton';

const AudienceProfilesIntro = () => {
  return (
    <section className='audience-profiles-intro'>
      <h2 className='audience-profiles-intro-title'>Data Guided by Deep Traveler Understanding</h2>
      <p className='audience-profiles-intro-desc'>
        Marriott Media is your traveler translator. We pair privacy-safe Marriott Bonvoy data with
        decades of knowing how our audiences move through the world.
      </p>
      <ScrollArrowButton targetId='audience-carousel' />
    </section>
  );
};

export default AudienceProfilesIntro;
